<template>
  <div>
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="150"
        >Cargando...</v-progress-circular
      >
    </v-overlay>
    <v-container fluid v-if="!isLoading">
      <!-- Carousel -->
      <!-- <v-carousel cycle hide-delimiter-background height="500px">
        <v-carousel-item
          v-for="(item, i) in carouselItems1"
          :key="i"
          reverse-transition="fade-transition"
        >
          <v-img
            :src="item.src"
            class="white--text fill-height"
            height="auto"
            cover
          >
            <v-container fill-height>
              <v-row align="center" justify="center">
                <v-col cols="12" md="8" class="text-center">
                  <h1 class="display-2 font-weight-bold">{{ item.title }}</h1>
                  <v-btn class="mt-4" color="primary" text>
                    {{ item.buttonText }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-img>
        </v-carousel-item>
      </v-carousel> -->

      <!-- *******CLIENTES************ -->
      <v-row justify="center" id="nuestros-clientes">
        <v-col cols="12" xs12 sm8 lg12>
          <v-row justify="space-around">
            <v-col cols="12" align="center">
              <v-divider></v-divider>
              <br />
              <h1 class="text mb-8 white--text">NUESTROS CLIENTES</h1>
              <v-divider></v-divider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!-- ANTIGUO -->
      <!-- <v-row justify="center" v-if="clientesFiltrados.length === 0">
        <v-col
          class="align-center"
          style="display: contents; zoom: 80%"
          cols="12"
          xs12
          sm12
          lg12
        >
          <div id="img" class="contenedor-empresas">
            <div v-for="image in empresasFiltradas" :key="image.id_cliente">
              <router-link
                :to="{ name: 'empresas', query: { codigo: image.id_cliente } }"
              >
                <div class="contenedor-img">
                  <img
                    style="max-height: auto; max-width: auto"
                    :src="image.logo2"
                    :alt="image.nombre"
                    class="imagenes-empresas"
                  />
                </div>
              </router-link>
            </div>
          </div>
        </v-col>
      </v-row> -->
      <!-- NUEVO -->

      <v-row justify="center">
        <v-col
          class="align-center"
          style="display: contents; zoom: 80%"
          cols="12"
          xs12
          sm8
          lg12
        >
          <div id="img" class="contenedor-empresas">
            <div
              v-for="cli in clientesFiltrados"
              :key="cli.id"
              v-if="cli.estado == 1"
            >
              <router-link
                :to="{ name: 'empresas', query: { codigo: cli.id_cliente } }"
                @click.native="seleccionarCliente(cli)"
              >
                <div class="contenedor-img">
                  <img
                    style="max-height: auto; max-width: auto"
                    :src="cli.logo2"
                    class="imagenes-empresas"
                  />
                </div>
              </router-link>
            </div>
          </div>
        </v-col>
      </v-row>
      <br />
      <!-- Carousel 2 -->
      <v-carousel cycle hide-delimiter-background height="500px">
        <v-carousel-item
          v-for="(item, i) in carouselItems2"
          :key="i"
          reverse-transition="fade-transition"
        >
          <v-img
            :src="item.src"
            class="white--text fill-height"
            height="auto"
            cover
          >
            <v-container fill-height>
              <v-row align="center" justify="center">
                <v-col cols="12" md="8" class="text-center">
                  <!-- <h1 class="display-2 font-weight-bold">{{ item.title }}</h1> -->
                  <v-btn class="mt-4" color="secondary">
                    {{ item.buttonText }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-img>
        </v-carousel-item>
      </v-carousel>
      <v-row justify="center" class="my-4">
        <v-col cols="12" class="text-center">
          <v-divider></v-divider>
          <h1 class="display-1 font-weight-bold mt-4 mb-8 white--text">
            ¿CÓMO PUEDO BUSCAR MI PEDIDO?
          </h1>
          <v-divider></v-divider>
        </v-col>
      </v-row>
      <v-row justify="center" spacing="24">
        <!-- Paso 1 -->
        <v-col cols="12" md="4">
          <v-card class="elevation-2 my-background" outlined>
            <v-card-title class="text-center">
              <v-icon large>mdi-magnify</v-icon>
              <!-- Icono para buscar -->
              <span class="ml-2">Paso 1</span>
            </v-card-title>
            <v-img
              src="../assets/myCard1.jpg"
              height="200px"
              class="white--text align-end"
              contain
            >
            </v-img>
            <v-card-text class="text-center">
              Haz clic en el logo del cliente que deseas buscar.
            </v-card-text>
          </v-card>
        </v-col>
        <!-- Paso 2 -->
        <v-col cols="12" md="4">
          <v-card class="elevation-2 myCard my-background" outlined>
            <v-card-title class="text-center">
              <v-icon large>mdi-keyboard</v-icon>
              <!-- Icono para escribir -->
              <span class="ml-2">Paso 2</span>
            </v-card-title>
            <v-img
              src="../assets/myCard2.jpg"
              height="200px"
              class="white--text align-end"
              contain
            >
            </v-img>
            <v-card-text class="text-center">
              Introduce el N° de orden y da clic en buscar.
            </v-card-text>
          </v-card>
        </v-col>
        <!-- Paso 3 -->
        <v-col cols="12" md="4">
          <v-card class="elevation-2 my-background" outlined>
            <v-card-title class="text-center">
              <v-icon large>mdi-history</v-icon>
              <!-- Icono para historial -->
              <span class="ml-2">Paso 3</span>
            </v-card-title>
            <v-img
              src="../assets/myCard3.jpg"
              height="200px"
              class="white--text align-end"
              contain
            >
            </v-img>
            <v-card-text class="text-center">
              Aparecerá el historial con estados y subestados.
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <br />
    </v-container>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import * as easings from "vuetify/es5/services/goto/easing-patterns";
export default {
  data() {
    return {
      filtro: "",
      srcTest: null,
      init: false,
      idOrdenClienteFinal: null,
      duration: 500,
      offset: -80,
      easing: "easeInOutCubic",
      easings: Object.keys(easings),
      texto: "azul",
      clienteSeleccionado: null,
      // windowX: 0,
      // windowY: 0,
      carouselItems1: [
        {
          src: require("../assets/camion1.jpg"),
          title: "Sigue tu pedido de forma segura y confiable",
          buttonText: "Visítanos",
        },
        {
          src: require("../assets/camion2.jpg"),
          title: "Tu solo llegas más rápido, pero juntos llegamos más lejos.",
          buttonText: "Visítanos",
        },
        {
          src: require("../assets/camion3.jpg"),
          title: "Encuentra tu pedido de manera fácil",
          buttonText: "Visítanos",
        },
      ],
      carouselItems2: [
        {
          src: require("../assets/camion4.jpg"),
          title: "Sigue tu pedido de forma segura y confiable",
          buttonText: "Visítanos",
        },
        {
          src: require("../assets/camion5.jpg"),
          title: "Tu solo llegas más rápido, pero juntos llegamos más lejos.",
          buttonText: "Visítanos",
        },
        {
          src: require("../assets/camion6.jpg"),
          title: "Encuentra tu pedido de manera fácil",
          buttonText: "Visítanos",
        },
      ],
    };
  },
  created() {
    if (this.theme == "light") {
      this.tcard = "tWhite";
      this.texto = "azul";
    } else if (this.theme == "dark") {
      this.tcard = "tBlack";
      this.texto = null;
    } else {
      this.tcard = "tWhite";
      this.texto = "azul";
    }
    this.setUrl(this.srcTest);
    setTimeout(() => {
      this.init = true;
      this.idOrdenClienteFinal = "";
    }, 300);
  },
  mounted() {
    this.listarCouriers();
  },
  computed: {
    isLoading() {
      return this.clientesFiltrados.length === 0;
    },
    ...mapGetters(["mapCouriers"]),
    ...mapState(["loading", "theme", "couriers", "url", "imagen"]),
    //empresasFiltradas: function () {
    //  return this.imagen.filter((image) => {
    //    return image.nombre.toLowerCase().match(this.filtro.toLowerCase());
    //  });
    //},
    clientesFiltrados: function () {
      return this.couriers.filter((couriers) => {
        return couriers.nombre.toLowerCase().match(this.filtro.toLowerCase());
      });
    },
  },
  watch: {
    theme: function () {
      if (this.theme == "light") {
        this.tcard = "tWhite";
        this.texto = "azul";
      } else {
        this.tcard = "tBlack";
        this.texto = null;
      }
    },
  },
  methods: {
    ...mapMutations(["setUrl"]),
    guardarUrl() {
      this.setUrl(this.srcTest);
    },
    listarCouriers() {
      this.$store.dispatch("listarCouriers");
    },
    seleccionarCliente(cliente) {
      this.clienteSeleccionado = cliente;
      console.log("Cliente seleccionado:", cliente);
    },
    selectCourier(courier) {
      this.$store.commit("setSelectedCourier", courier);
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Noto+Serif&display=swap");

.contenedor-img {
  width: 7rem;
  height: 7rem;
  background-color: rgb(255, 255, 255);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px solid rgb(0, 0, 0);
  border-radius: 10%;
}

.imagenes-empresas {
  width: 90%;
  cursor: pointer;
  border-radius: 5%;
}

/* .container--fluid {
  max-width: 100%;
  background-image: url("https://images.unsplash.com/photo-1729459101552-3830ac71a95d?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D");
  background-size: cover; 
  background-position: center; 
  background-repeat: no-repeat; 
} */

.contenedor-empresas {
  background-image: url("https://images.unsplash.com/photo-1729459101552-3830ac71a95d?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D");
  display: grid;
  width: 1260px;
  justify-content: center;
  min-height: 500px;
  max-height: 600px;
  gap: 3rem;
  grid-auto-rows: auto;
  opacity: 0.9;
  grid-template-columns: repeat(auto-fill, minmax(7.5rem, 1rem));
  /* background: rgba(0, 0, 0, 0.247); */
  border-top-left-radius: 25px;
  border-bottom-right-radius: 25px;
  overflow-x: auto;
  padding: 1.5rem;
  margin-bottom: 20px;
}

.contenedor-empresas div:hover {
  transform: scale(1.21);
}

::-webkit-scrollbar {
  width: 1.2vh;
  border-radius: 20px;
}

::-webkit-scrollbar-thumb {
  background-color: rgb(80, 80, 80);
  border-radius: 20px;
}

.texto-1 {
  width: 50%;
  color: white;
  font-size: 30px;
  text-transform: uppercase;
  font-family: "Noto Serif", serif;
}

.text {
  font-family: "Noto Serif", serif;
}

.contenedor-hero {
  width: 100%;
  height: auto;
}

.img-hero1 {
  width: 100%;
  height: 600px;
  background-image: url("../assets/camion1.jpg");
  background-repeat: no-repeat;
  background-position: 0% 80%;
  background-size: cover;
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
}

.card {
  width: 450px;
  height: 300px;
  padding: 10px;
  transition: 0.5s ease-out;
  color: black !important;
  border-radius: 28px;
  background: linear-gradient(45deg, #cacaca, #f0f0f0);
  box-shadow: 29px -29px 62px #b8b8b8, -29px 29px 62px #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.card h1 {
  margin-bottom: 10px;
}

.f-card {
  display: flex;
  text-align: center;
  gap: 3rem;
  flex-wrap: nowrap;
}

.img-t {
  width: 350px;
  height: 150px;
  background-size: cover;
  background-position: center;
}
@media screen and (max-width: 968px) {
  .f-card {
    display: flex;
    flex-direction: column;
  }

  .card {
    width: 350px;
  }
}

a {
  margin: 0px;
  padding: 0px;
  line-height: 0px;
}
</style>
